import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from './service';

var files = require.context('./modules', false, /\.js$/);

var apiGenerators = files.keys().map(function (key) {
  return files(key).default;
});
var api = {};
apiGenerators.forEach(function (generator) {
  var apiInstance = generator({
    request: request
  });

  for (var apiName in apiInstance) {
    if (apiInstance.hasOwnProperty(apiName)) {
      api[apiName] = apiInstance[apiName];
    }
  }
});
export default api;